import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { AccountProductEnum } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

interface NotificationBottomSheetBannerInterface {
  bottomSheetRef: RefObject<BottomSheetModal | null> | null;
  id: string;
}

const NotificationBottomSheetBanner = ({
  bottomSheetRef,
  id,
}: NotificationBottomSheetBannerInterface) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'paymentDetails',
  });

  const handlePay = () => {
    router.push({
      pathname: '/believe/make-payment',
      params: { id },
    });
    bottomSheetRef?.current?.dismiss();
  };
  const handleAddMoney = () => {
    router.push({
      pathname: '/move-money/transfer/transfer-money',
      params: {
        typeOfAccount: AccountProductEnum.ChargeCard,
      },
    });
    bottomSheetRef?.current?.dismiss();
  };

  return (
    <BottomSheet ref={bottomSheetRef}>
      <View
        style={styles.parentContainer}
        testID="notification-banner-bottom-sheet"
      >
        <View>
          <TitleMdText>{translatedText('addMoneyText')}</TitleMdText>
        </View>
        <View style={styles.childText}>
          <BodyBaseText>{translatedText('fullBalanceText')}</BodyBaseText>
          <BodyBaseText>{translatedText('believeCardText')}</BodyBaseText>
        </View>
        <View style={styles.buttonContainer}>
          <Button
            label={translatedText('buttons.addMoney')}
            type="PRIMARY"
            onPress={() => handleAddMoney()}
          />
          <Button
            label={translatedText('buttons.payPartially')}
            type="SECONDARY"
            onPress={() => handlePay()}
          />
        </View>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    gap: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
  childText: {
    gap: theme.spacing.l,
  },

  parentContainer: {
    gap: theme.spacing.m,
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
  },
});

export default NotificationBottomSheetBanner;
